import type {
  ChartConfig,
  ChartDataModel,
  ChartValidationResult,
  IChartPlugin,
  OptionSchema,
  RenderContext
} from '@chartforge/shared-types';
import { timelineChartSchemas } from '@chartforge/schema';
import { renderTimeline } from './render';
import { validateTimelineModel } from './validate';

export class TimelineChartPlugin implements IChartPlugin {
  readonly id = 'timeline';
  readonly displayName = 'Timeline';

  render(model: ChartDataModel, config: ChartConfig, ctx: RenderContext): void {
    renderTimeline(model, config, ctx);
  }

  getOptionSchemas(): OptionSchema[] {
    // Return a copy so callers cannot mutate the declarative schema.
    return [...timelineChartSchemas];
  }

  validate(model: ChartDataModel): ChartValidationResult {
    return validateTimelineModel(model);
  }
}

/** The singleton plugin instance registered into a ChartRegistry. */
export const timelineChart = new TimelineChartPlugin();
